import { render, staticRenderFns } from "./rolename.vue?vue&type=template&id=21fd8f1a"
import script from "./rolename.vue?vue&type=script&lang=js"
export * from "./rolename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports